
/*eslint-disable*/
import React from "react";
import {
  Badge,
  Card,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";
// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexHeader from "components/Headers/IndexHeader.js";
import AuthFooter from "components/Footers/AuthFooter.js";
import { useTranslation } from '../i18n/context';
// import { Link } from "react-router-dom";


function Index() {
  const { t } = useTranslation();
  return (
    <>
      <IndexNavbar />
      <div className="main-content">
        <IndexHeader />
        {/* <section className="py-6 pb-9 bg-default">
          <Container fluid id="explore">
            <Row className="justify-content-center text-center">
              <Col md="6">
                <h2 className="display-3 text-white" style={{ fontFamily: "gilroy-black", fontSize: "50px", fontWeight: "bold !important" }}>
                  {t('common.why')} aloPay
                </h2>
                <p className="lead text-white">
                  {t('common.handle')}<br />
                  {t('common.digital')}
                </p>
              </Col>
            </Row>
          </Container>
        </section> */}
        {/* <section className="section section-lg pt-lg-0 mt--7">
          <Container >
            <Row className="justify-content-center">
              <Col lg="12">
                <Row>
                  <Col lg="4">
                    <Card className="card-lift--hover shadow border-0">
                      <CardBody className="py-5">
                        <div className="icon icon-shape bg-gradient-info text-white rounded-circle mb-4">
                          <i className="ni ni-money-coins" />
                        </div>
                        <h4 className="h3 text-info text-uppercase">
                          {t('common.easy')}
                        </h4>
                        <p className="description mt-3">
                          {t('common.process')}<br /> {t('common.integrate')}
                        </p>
                        <div>
                          <Badge color="info" pill>
                            <span style={{ color: "white" }}>{t('common.secure')}</span>
                          </Badge>
                          <Badge color="info" pill>
                            <span style={{ color: "white" }}>{t('common.local')}</span>
                          </Badge>
                          <Badge color="info" pill>
                            <span style={{ color: "white" }}>{t('common.instant')}</span>
                          </Badge>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg="4">
                    <Card className="card-lift--hover shadow border-0">
                      <CardBody className="py-5">
                        <div className="icon icon-shape bg-gradient-success text-white rounded-circle mb-4">
                          <i className="ni ni-chart-bar-32" />
                        </div>
                        <h4 className="h3 text-success text-uppercase">
                          {t('common.real')}
                        </h4>
                        <p className="description mt-3">
                          {t('common.provide')}
                        </p>
                        <div>
                          <Badge color="success" pill>
                            {t('common.analytics')}
                          </Badge>
                          <Badge color="success" pill>
                            {t('common.insights')}
                          </Badge>
                          <Badge color="success" pill>
                            {t('common.time')}
                          </Badge>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg="4">
                    <Card className="card-lift--hover shadow border-0">
                      <CardBody className="py-5">
                        <div className="icon icon-shape bg-gradient-warning text-white rounded-circle mb-4">
                          <i className="ni ni-lock-circle-open" />
                        </div>
                        <h4 className="h3 text-warning text-uppercase">
                          {t('common.safe')}
                        </h4>
                        <p className="description mt-3">
                          {t('common.keep')}

                        </p>
                        <div>
                          <Badge color="warning" pill>
                            {t('common.secure')}
                          </Badge>
                          <Badge color="warning" pill>
                            {t('common.cloud')}
                          </Badge>
                          <Badge color="warning" pill>
                            {t('common.encrypt')}
                          </Badge>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section> */}
        <section className="py-6">
          <Container>
            <Row className="row-grid align-items-center">
              <Col md="6">
                <img
                  alt="..."
                  className="img-fluid"
                  src={require("assets/img/brand/alopay content.png")}
                />
              </Col>
              <Col md="6">
                <div className="pr-md-5">
                  <h1>{t('common.our')}
                    <span style={{ color: "#040b3f  !important", fontFamily: "gilroy-black", fontSize: "50px", fontWeight: "bold !important" }}> {t('common.solution')} </span></h1>
                  <p>
                    {t('common.aloapp')} <br /> {t('common.offer')}
                  </p>
                  <ul className="list-unstyled mt-5">
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                        <div>
                          <Badge className="badge-circle mr-3" color="success">
                            <i className="ni ni-settings-gear-65" />
                          </Badge>
                        </div>
                        <div>
                          <h4 className="mb-0">{t('common.easyPayment')}</h4>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                        <div>
                          <Badge className="badge-circle mr-3" color="success">
                            <i className="ni ni-html5" />
                          </Badge>
                        </div>
                        <div>
                          <h4 className="mb-0">{t('common.invoiceGe')}</h4>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                        <div>
                          <Badge className="badge-circle mr-3" color="success">
                            <i className="ni ni-satisfied" />
                          </Badge>
                        </div>
                        <div>
                          <h4 className="mb-0">{t('common.receiptsGe')}</h4>
                        </div>
                      </div>
                    </li>
                  </ul>
                  {/* <Link
                    className="font-weight-bold text-warning mt-5"
                    to="/admin/profile"
                  >
                    Explore pages
                  </Link> */}
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="py-6">
          <Container>
            <Row className="row-grid align-items-center">
              <Col className="order-md-2" md="6">
                <img
                  alt="..."
                  className="img-fluid"
                  src={require("assets/img/brand/alopay content.png")}
                />
              </Col>
              <Col className="order-md-1" md="6">
                <div className="pr-md-5">
                  <h1>{t('common.easyPayment')}<span style={{ color: "#040b3f  !important", fontFamily: "gilroy-black", fontSize: "50px", fontWeight: "bold !important" }}> {t('common.processing')}</span></h1>
                  <p>
                    {t('common.processPay')}
                  </p>
                  <ul className="list-unstyled mt-5">
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                        <div>
                          <Badge className="badge-circle mr-3" color="success">
                            <i className="ni ni-settings-gear-65" />
                          </Badge>
                        </div>
                        <div>
                          <h4 className="mb-0">{t('common.secure')}</h4>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                        <div>
                          <Badge className="badge-circle mr-3" color="success">
                            <i className="ni ni-briefcase-24" />
                          </Badge>
                        </div>
                        <div>
                          <h4 className="mb-0">{t('common.local')}</h4>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center">
                        <div>
                          <Badge className="badge-circle mr-3" color="success">
                            <i className="ni ni-mobile-button" />
                          </Badge>
                        </div>
                        <div>
                          <h4 className="mb-0">{t('common.instant')}</h4>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        {/* 
        <section className="py-6">
          <Container>
            <Row className="row-grid align-items-center">
              <Col md="6">
                <img
                  alt="..."
                  className="img-fluid"
                  src={require("assets/img/theme/landing-2.png")}
                />
              </Col>
              <Col md="6">
                <div className="pr-md-5">
                  <h1>Example pages</h1>
                  <p>
                    If you want to get inspiration or just show something
                    directly to your clients, you can jump start your
                    development with our pre-built example pages.
                  </p>
                  <Link
                    className="font-weight-bold text-warning mt-5"
                    to="/admin/profile"
                  >
                    Explore pages
                  </Link>
                </div>
              </Col>
            </Row>
          </Container>
        </section> */}

      </div>
      <AuthFooter />
    </>
  );
}

export default Index;
